<template>
  <div class="fi-plan-board" style="margin:20px">

    <FiPageRail title="Planned - Vehicle Utilization Monthly" />

    <div style="position: relative; font-size: 22px; font-weight: bold;" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;|&nbsp;&nbsp;Overnight Offset: &nbsp;<b-form-select v-model="selected_hours_offset" :options="hours_offset_options" style="font-size: 18px; font-weight: bold; width:100px"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
    </div>
    <br/>
    <div v-if="!loading">
      <div class="row" style="margin-right:10px; font-weight: bold; font-size: 20px;">
        <template v-for="type_stat in summary.vehicle_type_stats">
          <div @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color }">{{type_stat.count}} {{type_stat.type}}</div>
        </template>
      </div>
      <br/>
      <template v-for="chunk in items">
        <div class="align-right d-flex justify-content-center" style='display: flex; flex-wrap: nowrap'>
          <div style="max-width: 250px; min-width: 250px !important; border: 1px solid black; margin-top:5px" v-for="(day_record,day_idx) in chunk">
            <div style="background-color: #ddd; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}</div>
            <div style="background-color: #eee; font-weight: bold; font-size:16px; text-align:center">{{day_record.movements.length}} Total</div>
            <template v-if="selected_type == null || selected_type == type_cnt.type" v-for="type_cnt in day_record.type_cnts">
              <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isVehiclesVisible')"><b>{{type_cnt.type}} : {{type_cnt.cnt}}</b></div>
                <span :style="type_cnt.isVehiclesVisible ? '' : 'display:none'" v-if="item.vehicle_type == type_cnt.type" v-for="(item, idx) in day_record.movements">
                  <div @click="toggle_div(item,'isVisible')" style="border: 1px dotted darkgrey; margin: 4px;">
                    <b>{{item.vehicle}}</b>
                    <div v-if="item.charterID && item.isVisible">
                      &nbsp;&nbsp;<b>BookingID:</b> {{item.bookingID}}<br/>
                      &nbsp;&nbsp;<b>Vehicle:</b> {{item.vehicle}}<br/>
                      &nbsp;&nbsp;<b>Start:</b> {{item.start_datetime | formatDateTimeSmall}}<br/>
                      &nbsp;&nbsp;<b>Finish:</b> {{item.finish_datetime | formatDateTimeSmall}}
                    </div>
                  </div>
                </span>
            </template>
          </div>
        </div>
        <br/>
      </template>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {get_vehicle_type_calendar} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'

export default {
  name: 'planned_vehicle_types_monthly',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment().startOf('month')),
      details_toDate: justDate(moment().endOf('month')),
      selected_type: null,
      selected_hours_offset: '',
      hours_offset_options: [
        { value: '0', text: 'None' },
        { value: '1', text: '1AM' },
        { value: '2', text: '2AM' },
        { value: '3', text: '3AM' },
        { value: '4', text: '4AM' },
        { value: '5', text: '5AM' },
        { value: '6', text: '6AM' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.load_data()
    },
    showHighlightsForDate(movements) {
      for(const item of movements) {
        item.isHighlightsVisible = !item.isHighlightsVisible;
      }
      this.$forceUpdate();
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
    },
    showDetailsForDate(movements) {
      for(const item of movements) {
        item.isVisible = !item.isVisible;
      }
      this.$forceUpdate();
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async load_data() {

      this.loading = true
      try {
        const { value: { data = [] }} = await get_vehicle_type_calendar(this.user.tenant, this.selected_hours_offset, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.selected_hours_offset = this.summary.hours_offset
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    getStyleForVehicleID(color) {
      if (color != null)
        return 'border-radius: 10px; background-color:' + color
      return '';
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_toDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_fromDate = justDate(moment(this.details_toDate, 'MM-DD-YYYY').startOf('month'))
    },
    details_fromDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY')) {
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').endOf('month'))
      }

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        alert("please limit tag based date range to 31 days or less")
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').endOf('month'))
      }
    },
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
